const navigation_main = document.querySelector(".navigation-main")
const submenus = document.querySelectorAll(".submenu")

submenus.forEach(submenu => {
  const class_item = `.${submenu.id}.navigation_item.has-submenu`
  const menu_item = navigation_main.querySelector(class_item)
  menu_item.appendChild(submenu)
});
